module.exports = new __parcel__URL__("teamsoftware-icon.1b347204.jpg").toString();